const Wistia = {
  API_KEY: '5675939973e324cdfc8cce4e264b8f4b35546c2fdac7ec9582a60c236fab88b8'
}
export default Wistia
